import {isApolloError} from '@apollo/client'

export const getRequestProcedureErrors = (err: unknown): string[] | undefined => {
  if (!(err instanceof Error && isApolloError(err))) {
    return
  }

  const extensions = err.graphQLErrors[0]?.extensions || {}
  if (extensions['code'] === 'FAILED_PRECONDITION' && Array.isArray(extensions['messages'])) {
    return extensions['messages'] as string[]
  } else {
    return
  }
}
